import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { Props } from './ShopPremiumFolders';
import { AppState } from '../../../../../types/store';
import { getShopItemsStreamId } from '../../../../streams/shop';
import { ShopItemType } from '../../../../../types/shop';

export type DispatchProps = Pick<Props, 'onCreate'>;
type StateProps = Pick<Props, 'total'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const streamId = getShopItemsStreamId(ShopItemType.PREMIUM_FOLDERS);
  const itemIds = streamSelectors.getItems(state, streamId);

  return {
    total: itemIds.length,
  };
};

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => {
  return {
    onCreate: () =>
      dispatch(
        pushModal(ModalType.CREATE_PREMIUM_FOLDER, {
          wrapInModal: false,
        })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps);
